import { Checkbox, useMantineTheme } from '@mantine/core';

import dt from '~/domains/contest/domains/managev2/domains/common/testing.const';
import { Text } from '~/domains/design-system/Text';
import { Tooltip } from '~/domains/common/components/Tooltip/Tooltip';

import type { SelectFieldOption } from '../../SingleSelectField/types';

interface MainOptionsProps {
  options: SelectFieldOption[];
  value: unknown;
  sectionKey: string;
  fieldKey: string;
  fieldDescription?: string;
  classes: Record<string, string>;
  onOptionChange: (optionValue: string | number | boolean | { fieldKey: string }) => void;
}

export function MainOptions({
  options,
  value,
  sectionKey,
  fieldKey,
  fieldDescription,
  classes,
  onOptionChange,
}: MainOptionsProps) {
  const theme = useMantineTheme();

  return (
    <>
      {fieldDescription ? (
        <Text c="gray2.3" ta="center" variant="body-large">
          {fieldDescription}
        </Text>
      ) : null}

      {options?.map((option, i) => {
        const isChecked =
          value === option.value ||
          (option.value === 'custom' && typeof value === 'string' && value.startsWith('custom_'));

        return (
          <Tooltip
            isRendered={!!option.params?.tooltip}
            withinPortal
            position="top-start"
            key={`${option.value}`}
            label={option.params?.tooltip}
          >
            <span>
              <Checkbox
                pb={theme.other.spacing._8}
                w="100%"
                radius="lg"
                classNames={classes}
                data-test-id={dt.checkOption}
                checked={isChecked}
                wrapperProps={{ 'data-test-id': dt.field(sectionKey, [fieldKey]) }}
                disabled={option.isDisabled}
                sx={{ borderBottom: `1px solid ${theme.colors.gray2[0]}` }}
                onChange={() => onOptionChange(option.value)}
                label={<Text variant="headline-medium">{option.label}</Text>}
              />
            </span>
          </Tooltip>
        );
      })}
    </>
  );
}
